import * as z from 'zod';
import { TFunction } from 'i18next';

export const CRYPTO_WALLET_ADDRESS_REGEX = /^(0x[a-fA-F0-9]{40}|T[1-9A-HJ-NP-Za-km-z]{33})$/;

export const createCryptoWalletAddressSchema = (t: TFunction) =>
  z
    .string({ error: t('walletAddressRequired') })
    .trim()
    .min(1, t('walletAddressRequired'))
    .regex(CRYPTO_WALLET_ADDRESS_REGEX, t('invalidWalletAddress'));
